import { faFileAlt } from "@fortawesome/free-solid-svg-icons";
import { FC, createRef, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import * as yup from "yup";
import ModalComponent from "../../../../../core/components/modal/modal.component";
import TableComponent from "../../../../../core/components/table/table.component";
import FormBuilderComponent, {
  FormConfig,
} from "../../../../../shared/form-builder/form-builder.component";
import { fetchModulesForAccessMapping } from "../../../../../store/slices/navbar.slice";
import {
  getRoleById,
  getRoles,
  savePermissionForRole,
} from "../../../../../store/slices/role.slice";
import SearchBarComponent from "../../search-bar/search-bar.component";
import "../../../admin.scss";

interface RoleTableComponentProps {
  columns: any;
  data: any[];
  totalNumberOfRecords: number;
  pageSize: number;
  current: number;
  onChangePage: any;
  onChangeSort: any;
  isLoading: boolean;
  onSearch: (val: string) => void;
}

const RoleTableComponent: FC<RoleTableComponentProps> = ({
  columns,
  data,
  totalNumberOfRecords,
  pageSize,
  current,
  onChangePage,
  onChangeSort,
  isLoading,
  onSearch,
}) => {
  const formRef = createRef();
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [isDetails, setIsDetails] = useState<boolean>(false);
  // const [isEdit, setIsEdit] = useState<boolean>(false);
  const [initialValues, setInitialValues] = useState<any>({
    role: "",
    roleDetail: "",
  });

  let selectedActionIds: any = [];
  const [selectedRoleId, setSelectedRoleId] = useState();

  const dispatch = useDispatch();

  const roleDetails = useSelector((state: any) => {
    return state.role.roleDetails;
  });

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setIsDetails(false);
    // setIsEdit(false);

    setInitialValues({
      role: "",
      roleDetail: "",
    });
  };

  const detailsAction = (id: number) => {
    setIsModalOpen(true);
    setIsDetails(true);
    // setIsEdit(false);
    dispatch(getRoleById({ id }));
    dispatch(fetchModulesForAccessMapping({ RoleId: id }));
  };

  /*   const editAction = (id: number) => {
    setIsModalOpen(true);
    setIsEdit(true);
    setIsDetails(false);
    dispatch(getRoleById({ id }));
    dispatch(fetchModulesForAccessMapping({ RoleId: id }));
  }; */

  useEffect(() => {
    if (!roleDetails || !Object.keys(roleDetails).length) return;

    setInitialValues({
      role: roleDetails.name,
      roleDetail: roleDetails.roleDetail,
    });
    setSelectedRoleId(roleDetails.id);
  }, [roleDetails]);

  const actionConfig: any = [
    /*     {
      label: "Edit",
      actionProperty: "id",
      event: editAction,
      variant: "info",
      className: "mx-2 my-1",
      moduleName: "Role",
      actionName: "Edit-Role",
      icon: faPencilAlt,
    }, */
    {
      label: "View",
      actionProperty: "id",
      event: detailsAction,
      variant: "info",
      className: "mx-2 my-1",
      moduleName: "Role",
      actionName: "View-Role",
      icon: faFileAlt,
    },
  ];

  const emptyConfig = {
    title: "No Role Found",
    description: "",
  };

  const formConfig: FormConfig = {
    controls: [
      {
        name: "role",
        label: "Role",
        placeholder: "TC Admin",
        type: "text",
        required: !isDetails,
        readOnly: true,
        disabled: true,
      },
      {
        name: "roleDetail",
        label: "Role Description",
        placeholder: "Role Description",
        type: "textarea",
        disabled: true,
        readOnly: true,
        display: isDetails,
        rows: 5,
      },
    ],
  };

  const validationSchema = yup.object().shape({
    role: yup
      .string()
      .min(5, "Role must be at least 5 characters")
      .required("Role is required"),
  });

  /*   const onChangeActionIds = (id: any, value: any) => {
    let copySelectedActionIds = [...selectedActionIds];
    if (value) {
      if (!copySelectedActionIds.find((n: any) => n === id)) {
        copySelectedActionIds.push(id);
      }
    } else {
      if (copySelectedActionIds.find((n: any) => n === id)) {
        copySelectedActionIds = copySelectedActionIds.filter(
          (n: any) => n !== id
        );
      }
    }

    selectedActionIds = copySelectedActionIds;
    console.log(selectedActionIds);

    // setSelectedActionIds(copySelectedActionIds);
  }; */

  const save = () => {
    if (!selectedRoleId) {
      toast.warning("Please select a role first", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnFocusLoss: true,
        draggable: true,
        pauseOnHover: true,
      });
    } else {
      dispatch(
        savePermissionForRole({
          roleId: Number.parseInt(selectedRoleId),
          actionIds: selectedActionIds,
        })
      );
    }
    setIsModalOpen(false);
  };

  const modalActionConfig: any = isDetails
    ? []
    : [
      {
        label: "Save",
        event: save,
        variant: "primary",
      },
    ];

  return (
    <div>
      <div>
        <div className="d-flex gap-3 justify-content-end table-generic-action  table-toolbar">
          <SearchBarComponent
            placeholder="Search Role"
            methodToDispatch={getRoles}
            getSearch={onSearch}
          />
        </div>
        <div className="my-3">
          <TableComponent
            tableHeaders={columns}
            emptyConfig={emptyConfig}
            data={data}
            totalNumberOfRecords={totalNumberOfRecords}
            pageSize={pageSize}
            current={current}
            onChangePage={onChangePage}
            actionConfig={actionConfig}
            onChangeSort={onChangeSort}
            isLoadingData={isLoading}
          />
        </div>
      </div>

      {/* modals */}
      {isModalOpen && (
        <ModalComponent
          showModal={isModalOpen}
          handleClose={handleCloseModal}
          headerTitle={isDetails ? "Role Details" : "Role Edit"}
          actionConfig={modalActionConfig}
        >
          <FormBuilderComponent
            formRef={formRef}
            initialValues={initialValues}
            validation={validationSchema}
            formConfig={formConfig}
          />
          {/* <div className="mt-3">
            <div style={{ fontSize: "18px", fontWeight: "700" }}>
              Access Mapping
            </div>
            <div className="mt-3">
              {isDetails ? (
                <AccessMappingViewComponent />
              ) : (
                <AccessMappingComponent onChangeActionIds={onChangeActionIds} />
              )}
            </div>
          </div> */}
        </ModalComponent>
      )}
    </div>
  );
};

export default RoleTableComponent;
